import Component from '@bythepixel/component-loader';

export default class asyncIframe extends Component {
  static selector = '[data-comp-async-iframe]';

  constructor(iframeEl) {
    super(iframeEl);
    const selectorBase = asyncIframe.selector.slice(0, -1);
    this.triggerEl = this.$container.querySelector(`${selectorBase}-trigger]`);
    this.iframeEl = this.$container.querySelector(`${selectorBase}-iframe]`);

    this.url = this.$container.dataset.compAsyncIframe;
    this.boundOnClick = () => this.onClick();
    this.triggerEl.addEventListener('click', () => this.boundOnClick(), 1);
  }

  onClick() {
    this.iframeEl.addEventListener('transitionend', this.boundCleanup);
    this.boundOnLoad = () => this.onLoad();
    this.iframeEl.addEventListener('load', this.boundOnLoad);
    requestAnimationFrame(() => {
      this.iframeEl.src = this.$container.dataset.compAsyncIframe;
      this.$container.classList.add('async-iframe--activated');
    });
  }

  onLoad() {
    this.iframeEl.removeEventListener('load', this.boundOnLoad);
  }

  cleanup() {
    this.boundCleanup = () => this.cleanup();
    this.iframeEl.removeEventListener('load', this.boundCleanup);
    this.iframeEl.removeAttribute(asyncIframe.selector.replace(/[[\]']+/g, ''));
  }
}
